import styled from 'styled-components';
import { COLOR } from 'assets/styles/colors';
import BREAKPOINT from 'assets/styles/breakpoints';

export const CardWrapper = styled.div`
  position: fixed;
  top: 150px;
  z-index: 100;
  padding: ${({ services }) => (services ? '24px 0px 24px 18px' : '24px 18px')};
  background: ${COLOR.WHITE_1};
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.45);
  border-radius: 6px;
  max-width: 580px;
  h3 {
    margin-bottom: 16px;
  }

  .MuiIconButton-root {
    position: absolute;
    top: 0;
    right: 0;
  }

  /* Tablet */
  @media screen and (max-width: ${BREAKPOINT.MD}) {
    top: ${({ services }) => (services ? '115px' : '115px')};
    height: ${({ services, height }) => (services && `${height}px`)};
    left: 18px;
    right: 18px;
  }
`;

export const BoxText = styled.div`
  overflow-y: scroll;
  padding-right: 18px;
  ::-webkit-scrollbar {
    width: 5px;
    border-radius: 50%;
  }
  /* Track */
  ::-webkit-scrollbar-track {
    background: rgba(43, 147, 138,0.3);
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: ${COLOR.GREEN_1};
    border-radius: 100px;
  }

  p {
    margin-bottom: 16px;
    bold {
      font-weight: 500;
    }
  }
  a > p {
    text-decoration: underline;
    width: 85%;
    color:  ${COLOR.GREEN_1};
  }
  /* Tablet */
  @media screen and (max-width: ${BREAKPOINT.MD}) {
    max-height: ${({ maxHeight }) => `${maxHeight}px`};
  }
  /* Tablet */
  @media screen and (min-width: ${BREAKPOINT.MD}) {
    max-height: 220px;
  }
`;

export const BoxButton = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  button {
    width: 100%;
    margin: 32px auto 0 auto;
    max-width: 288px;
  }

  /* Desktop */
  @media screen and (min-width: ${BREAKPOINT.LG}) {
    button {
      margin: 32px auto 0 auto;
      max-width: 320px;
    }
  }
`;
